export const ACCOUNT_INFO_GET = 'ACCOUNT_INFO_GET'

export const CHANGE_ACCOUNT = 'CHANGE_ACCOUNT'
